import { FormGroup } from '@angular/forms';

export class FormUtils {

  static markAllControlsTouchedAndValidate(form: FormGroup): void {
    Object.keys(form.controls).forEach(controlName => {
      form.controls[controlName].markAsTouched();
      form.controls[controlName].updateValueAndValidity();
    });
  }
}

